import { Button } from '@/ui-kit';
import styles from './button-submit-step.module.scss';
import clsx from 'clsx';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import WebApp from '@twa-dev/sdk';
import { useEffect, useState } from 'react';
import { useVibration } from '@/store/useVibration';
interface Props {
    isLoading?: boolean;
    stepNumber: number;
    href?: string;
    isDisabled?: boolean;
    isGray?: boolean;
    title?: string;
}

export const ButtonSubmitStep: React.FC<Props> = ({
    stepNumber = 1,
    isLoading,
    href,
    isDisabled,
    isGray,
    title = 'Продолжить',
}) => {
    const { isVibrationEnabled } =
        useVibration(state => state);

    const btnClick = () => {
        if (stepNumber === 1) {
            callYaMetrika('clicked_next_screen_tell_about_yourself');
        }
        if (stepNumber === 2) {
            callYaMetrika('clicked_next_screen_upload_photos');
        }
        if (stepNumber === 3) {
            callYaMetrika('Clicked_screen_who_you_looking_for');

            callYaMetrika('сomplete_registration');

            if (isVibrationEnabled) {
                WebApp
                    .HapticFeedback
                    .impactOccurred('medium');
                // pass for not android
                navigator.vibrate?.(10)
            }
        }
    };

    return (
        <div className={clsx(styles.wrapperButtonStep, isGray && styles.gray)}>
            <Button
                type="submit"
                variant="stretched"
                typeColor="orange"
                isLoading={isLoading}
                isDisabled={isDisabled}
                isLink={!!href}
                to={href}
                onClick={btnClick}
            >
                {title}
            </Button>
        </div>
    );
};
